<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item :label="'订单提交日期'">
              <a-range-picker
                v-model="queryParam.endTime"
                format="YYYY-MM-DD HH:mm:ss"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                :show-time="{ format: 'HH:mm:ss' }"
                style="width: 100%;"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'产品类型'">
              <a-select
                v-model='queryParam.appssid'

              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'是否失效'">
              <a-select
                v-model='queryParam.approvalStatus'
              >
                <a-select-option value=''>全部</a-select-option>
                <a-select-option value='4'>未失效</a-select-option>
                <a-select-option value='5'>已失效</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'是否领取'">
              <a-select
                v-model='queryParam.ext'
              >
                <a-select-option value=''>全部</a-select-option>
                <a-select-option value='1'>未领取</a-select-option>
                <a-select-option value='2'>已领取</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
<!--          <a-col :span="6">-->
<!--            &lt;!&ndash;     审核状态&ndash;&gt;-->
<!--            <a-form-item label="是否失效">-->
<!--              <dict-select-->
<!--                v-model='queryParam.approvalStatus'-->
<!--                :dict-code='DICT_CODE.APPROVAL_STATUS'-->
<!--                :begin="[{ value: '', label: '全部', labelEn: 'All',labelTi: 'ทั้งหมด' }]"-->
<!--                :placeholder="$t('select')"-->
<!--              />-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--       -->
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
                <a-button type='primary' @click="downLoadData()" icon='download'
                          style='margin-left: 8px'>{{ $t('exportFile')
                  }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered
      >
      </a-table>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {  findNotReceiveAmountList, getApplist } from '@/webpublicapi/order'
import vModal from '../modules/Modal';
import moment from 'moment'
import exportFile from '@/api/exportFile'
import DictSelect from '@/views/webpublic/modules/DictSelect.vue'

const I18N_KEY = 'order.';
export default {
  name: 'loanStatusLoanCount',
  components: {
    DictSelect,
    vModal,
  },
  data () {
    return {
      I18N_KEY,
      toggleSearchStatus:false,
      visibleRepayUrlCard: false,
      repayUrl: '',
      visible: false,
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      dataSource: [],
      appList: [],
      // 查询条件
      queryParam: {
        // endTime: [moment().add('days', -1), moment().add('days', 0)],
        endTime: [
          moment().add('days', -1).startOf('day'), // 当前时间往前推一天的开始时间（午夜00:00:00）
          moment().endOf('day') // 当前时间的结束时间（23:59:59）
        ],
        'appssid': '',
        "approvalStatus":'4',
        "ext":'1',
      },
      loading: false,
      // 表头
      isorter: {
        column: 'd',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns () {
      return [
        {
          title: '姓名',
          align: 'left',
          dataIndex: 'names'
        },
        {
          title: '手机号',
          align: 'left',
          dataIndex: 'custMobileNo'
        },
        {
          title: '产品名称(盘号)',
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: '订单提交时间',
          align: 'left',
          dataIndex: 'submitTime'
        },
        {
          title: '订单更新时间',
          align: 'left',
          dataIndex: 'updatedTime'
        }
      ]
    },
  },
  created () {
    getApplist().then(res => {
      this.appList = res.data || []
    })
    this.loadData(1)
  },
  methods: {
    downLoadData () {
      var params = this.getQueryParams()// 查询条件
      console.log('下载参数',params)
      const file = {
        fileUrl: '/api/web/webpublic/order/findNotReceiveAmountListExcel?startDate='
          + params.startDate + '&endDate=' + params.endDate + '&approvalStatus=' + params.approvalStatus + '&appssid=' + params.appssid + '&ext=' + params.ext,
        fileName:    "NotReceiveAmount" + params.startDate  + params.endDate +'.xlsx',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      console.log('params--->', params.appssid)

      findNotReceiveAmountList(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.dataSource = res.data
          // this.total = res.data.total

        }else{
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
    transformStringToLow (str) {
      return str && str.toLocaleLowerCase();
    },
    getQueryParams () {
      const { endTime } = this.queryParam;
      const data = {
        ...this.queryParam,
        startDate: (endTime && endTime.length) ? this.transformTime(endTime[0]) : undefined,
        endDate : (endTime && endTime.length) ? this.transformTime(endTime[1]) : undefined,
      }
      delete data.endTime;
      // 设置默认值
      if (!data.approvalStatus) {
        data.approvalStatus = '4';
      }
      if (!data.ext) {
        data.ext = '1';
      }
      var param = Object.assign({}, data)
      // param.pageNum = this.form.pageNum
      // param.pageSize = this.form.pageSize
      // return filterObj(param)
      return param
    },
    handleTableChange (pageNum, pageSize) {
      this.form.pageNum = pageNum;
      this.form.pageSize = pageSize;
      this.loadData();
    },
    // 重置字典类型搜索框的内容
    searchReset () {
      var that = this
      that.queryParam.appssid = ''
      that.queryParam.endTime = undefined

    },
    changeModal (visible) {
      this.visible = visible;
    }
  }
}
</script>
<style lang="less" scoped>
@import "~@/assets/less/common.less";
</style>
